import { Input, RadioGroup, SelectInput } from '../../components/common/atoms'
import { pencil_img } from '../../assets/images'

const familyUpdateSchema = ({ data, index, toggleEdit, changeHandler, saveHandler }) => {
  return (
    <tr key={String(data.edit) + index} className='text-gray-600'>
      <td className='pl-3 pr-5 py-4 font-semibold' style={{ width: '17%' }}>
        {data.edit ? <Input value={data.first_name || ''} inputClasses='text-gray-700 text-base leading-4 font-semibold' type='text' name='first_name' handler={(event) => changeHandler(index, event.target.name, event.target.value)} /> : data.first_name}
      </td>

      <td className='pl-3 pr-5 py-4 font-semibold' style={{ width: '17%' }}>
        {data.edit ? <Input value={data.last_name || ''} inputClasses='text-gray-700 text-base leading-4 font-semibold' type='text' name='last_name' handler={(event) => changeHandler(index, event.target.name, event.target.value)} /> : data.last_name}
      </td>

      <td className='pl-3 pr-5 py-4 font-semibold' style={{ width: '17%' }}>
        {data.edit ? (
          <SelectInput
            value={data.relation}
            selectList={['Father', 'Mother', 'Brother', 'Sister', 'Wife', 'Son', 'Daughter', 'Mother in law', 'Father in law', 'Other']}
            name='relation'
            iconPosition='92%'
            inputClasses='text-gray-700 text-base leading-4 font-semibold'
            handler={(event) => changeHandler(index, event.target.name, event.target.value)}
          />
        ) : (
          data.relation
        )}
      </td>

      <td className='pl-3 pr-5 py-4 font-semibold' style={{ width: '17%' }}>
        {data.edit ? (
          <Input value={data.date_of_birth || ''} inputClasses='text-gray-700 text-base leading-4 font-semibold' placeholder='DD-MM-YYYY' type='text' name='date_of_birth' maxLength='10' handler={(event) => changeHandler(index, event.target.name, event.target.value, event.nativeEvent.inputType)} />
        ) : (
          data.date_of_birth
        )}
      </td>

      <td className='pl-3 pr-5 py-4 font-semibold' style={{ width: '17%' }}>
        {data.edit ? (
          <RadioGroup
            radioList={['Male', 'Female']}
            name={'gender' + index}
            value={data.gender}
            radioInputClasses='h-5 w-5'
            labelClases='ml-3 font-proxima-nova text-gray-700 text-base leading-4 font-semibold'
            handler={(event) => changeHandler(index, event.target.name, event.target.value)}
            radioClasses='grid-cols-2 gap-3'
          />
        ) : (
          data.gender
        )}
      </td>

      <td  className = "py-4">
        {data.edit ? (
          <div>
            <button className='border border-gray-275 text-blue-600 font-semibold py-2.5 px-4 rounded-md focus:outline-none hover:border-' onClick={() => toggleEdit(index, 'close')}>
              Cancel
            </button>
            <button className='bg-blue-600 text-white font-semibold py-2.5 px-4 rounded-md ml-2 focus:outline-none hover:bg-blue-600' onClick={() => saveHandler(index)}>
              Save
            </button>
          </div>
        ) : (
          <img src={pencil_img} alt='navigation-icon' className='cursor-pointer' onClick={() => toggleEdit(index, 'open')} />
        )}
      </td>
    </tr>
  )
}

export default familyUpdateSchema